// src/App.jsx
import React, { useState } from "react";
import { HomePage } from "./homePage.jsx";

// ---- Simple local login gate ----
const LOCAL_USER_ID = "agent";        // change as needed
const LOCAL_PASSWORD = "Cred@123";    // change as needed

function LoginScreen({ onLoginSuccess }) {
  const [userId, setUserId] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userId === LOCAL_USER_ID && password === LOCAL_PASSWORD) {
      setError("");
      onLoginSuccess();
    } else {
      setError("Invalid ID or Password");
    }
  };

  return (
    <div className="app-root">
      <div className="app-shell">
        <header className="app-header">
          <h1 className="app-header-title">Agent Login</h1>
        </header>

        <main className="app-main">
          <form onSubmit={handleSubmit} className="card" style={{ maxWidth: 360 }}>
            <div className="form-group">
              <label className="field-label" htmlFor="loginUserId">
                User ID
              </label>
              <input
                id="loginUserId"
                type="text"
                className="field-input"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                autoComplete="off"
              />
            </div>

            <div className="form-group">
              <label className="field-label" htmlFor="loginPassword">
                Password
              </label>
              <input
                id="loginPassword"
                type="password"
                className="field-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="off"
              />
            </div>

            {error && <p className="text-error">{error}</p>}

            <button type="submit" className="btn btn-primary" style={{ marginTop: 12 }}>
              Login
            </button>
          </form>
        </main>
      </div>
    </div>
  );
}

// ---- Tabs ----
const TABS = {
  HOME: "HOME",
  EMI: "EMI",
};

function App() {
  const [activeTab, setActiveTab] = useState(TABS.HOME);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // NEW

  // Show login first
  if (!isLoggedIn) {
    return <LoginScreen onLoginSuccess={() => setIsLoggedIn(true)} />;
  }

  // Existing app UI after login
  return (
    <div className="app-root">
      <div className="app-shell">
        <header className="app-header">
          <h1 className="app-header-title">Welcome, Agent.</h1>
        </header>

        <main className="app-main">
          {activeTab === TABS.HOME ? <HomePage /> : <EmiCalculatorPage />}
        </main>

        <BottomNav activeTab={activeTab} onChange={setActiveTab} />
      </div>
    </div>
  );
}

function BottomNav({ activeTab, onChange }) {
  return (
    <nav className="bottom-nav">
      <button
        className={
          "bottom-nav-item" +
          (activeTab === TABS.HOME ? " bottom-nav-item--active" : "")
        }
        onClick={() => onChange(TABS.HOME)}
      >
        Home
      </button>
      <button
        className={
          "bottom-nav-item" +
          (activeTab === TABS.EMI ? " bottom-nav-item--active" : "")
        }
        onClick={() => onChange(TABS.EMI)}
      >
        Check EMI
      </button>
    </nav>
  );
}

// ---- EMI helpers ----
const TENURE_OPTIONS = [
  { key: "RAPID", label: "Rapid", months: 1, days: 30 },
  { key: "E3", label: "E3", months: 3, days: 90 },
  { key: "E6", label: "E6", months: 6, days: 180 },
  { key: "E9", label: "E9", months: 9, days: 270 },
];

// Minimum downpayment helper
// export function getMinimumDownPayment(itemValue) {
//   const item = Number(itemValue) || 0;
//   if (item <= 0) return 0;

//   if (item <= 20000) {
//     // 25% for 20k or less
//     return Math.ceil(item * 0.25);
//   }

//   // base 20% for > 20k
//   const base = item * 0.2;
//   // ensure disbursement (item - dp) <= 27000
//   const minForCap = item - 27000; // DP needed so that item - DP <= 27000
//   const required = Math.max(base, minForCap);
//   return Math.ceil(required);
// }

export function calculateEmiOptions(itemValue, downPayment) {
  const item = Number(itemValue) || 0;
  const down = Number(downPayment) || 0;

  const disbursementAmount = Math.max(item - down, 0);
  if (disbursementAmount <= 0) return [];

  const processingRate = 0.1;
  const dailyRate = 0.00065753424658;

  const baseLoan = disbursementAmount / (1 - processingRate);
  const loanAmount = Math.ceil(baseLoan);
  const processingFee = loanAmount * processingRate;

  const today = new Date();

  // If disbursementAmount < 15000, remove E9 from tenure options
  const filteredTenures =
    disbursementAmount > 15000
      ? TENURE_OPTIONS
      : TENURE_OPTIONS.filter((t) => t.key !== "E9");

  return filteredTenures.map((t) => {
    const months = t.months;
    const days = t.days;

    const interest = loanAmount * dailyRate * days;
    const totalRepay = loanAmount + interest;
    const rawEmi = totalRepay / months;
    const emi = Math.ceil(rawEmi);

    const lastDate = new Date(today.getTime());
    lastDate.setDate(lastDate.getDate() + days);
    const lastRepaymentDate = lastDate.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    return {
      key: t.key,
      label: t.label,
      months,
      days,
      loanAmount,
      netDisbursement: disbursementAmount,
      emi,
      processingFee,
      interest,
      totalRepay,
      lastRepaymentDate,
    };
  });
}


// ---- EMI page ----
// function EmiCalculatorPage() {
//   const [itemValue, setItemValue] = React.useState("");
//   const [downPayment, setDownPayment] = React.useState("");
//   const [options, setOptions] = React.useState([]);
//   const [error, setError] = React.useState("");

//   const handleItemChange = (e) => {
//     const val = e.target.value;
//     setItemValue(val);

//     const num = Number(val) || 0;
//     const minDp = getMinimumDownPayment(num);
//     setDownPayment((prev) => {
//       const prevNum = Number(prev) || 0;
//       if (!prev && minDp > 0) return String(minDp); // auto-fill
//       if (prevNum < minDp) return String(minDp); // bump to min
//       return prev; // keep user higher value
//     });
//   };

//   const handleDownChange = (e) => {
//     const val = e.target.value;
//     const item = Number(itemValue) || 0;
//     const minDp = getMinimumDownPayment(item);
//     const num = Number(val) || 0;

//     if (num < minDp) {
//       setDownPayment(String(minDp));
//     } else {
//       setDownPayment(val);
//     }
//   };

//   const handleGenerate = () => {
//     setError("");
//     const item = Number(itemValue);
//     let down = Number(downPayment);

//     if (!item || item <= 0) {
//       setError("Enter a valid item value.");
//       setOptions([]);
//       return;
//     }

//     const minDp = getMinimumDownPayment(item);
//     if (down < minDp) {
//       down = minDp;
//       setDownPayment(String(minDp));
//     }

//     if (down < 0 || down > item) {
//       setError("Downpayment must be between minimum required and item value.");
//       setOptions([]);
//       return;
//     }

//     const result = calculateEmiOptions(item, down);
//     if (result.length === 0) {
//       setError("Loan amount must be greater than 0.");
//       setOptions([]);
//       return;
//     }
//     setOptions(result);
//   };

//   const handleReset = () => {
//     setItemValue("");
//     setDownPayment("");
//     setOptions([]);
//     setError("");
//   };

//   return (
//     <div className="page page-emi">
//       <h2 className="page-title">Check EMI</h2>

//       <div className="form-group">
//         <label className="field-label">Item Value</label>
//         <input
//           type="number"
//           className="field-input"
//           placeholder="Enter item value"
//           value={itemValue}
//           onChange={handleItemChange}
//         />
//       </div>

//       <div className="form-group">
//         <label className="field-label">Downpayment</label>
//         <input
//           type="number"
//           className="field-input"
//           placeholder="Auto min; you can increase"
//           value={downPayment}
//           onChange={handleDownChange}
//         />
//       </div>

//       {error && <p className="text-error">{error}</p>}

//       <div className="button-row">
//         <button className="btn btn-primary" onClick={handleGenerate}>
//           Generate
//         </button>
//         <button className="btn btn-secondary" onClick={handleReset}>
//           Reset
//         </button>
//       </div>
//       <p className="text-note">
//         * These EMIs are indicative and calculated as of{" "}
//         {new Date().toLocaleDateString("en-IN", {
//           day: "2-digit",
//           month: "short",
//           year: "numeric",
//         })}
//         .
//       </p>

//       {options.length > 0 && (
//         <div className="card-list card-list--emi">
//           {options.map((opt) => (
//             <div key={opt.key} className="card emi-card">
//               <div className="card-header-row">
//                 <div className="emi-title">
//                   {opt.label} • {opt.months} month
//                   {opt.months > 1 ? "s" : ""}
//                 </div>
//               </div>

//               <div className="emi-row">
//                 <span className="emi-label">Loan Amount</span>
//                 <span className="emi-value">
//                   ₹{opt.loanAmount.toFixed(0)}
//                 </span>
//               </div>

//               <div className="emi-row">
//                 <span className="emi-label">Net Disbursement</span>
//                 <span className="emi-value">
//                   ₹{opt.netDisbursement.toFixed(0)}
//                 </span>
//               </div>

//               <div className="emi-row emi-row--highlight">
//                 <span className="emi-label">Monthly EMI</span>
//                 <span className="emi-value emi-value--primary">
//                   ₹{opt.emi.toFixed(0)}
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

function EmiCalculatorPage() {
  const [itemValue, setItemValue] = React.useState("");
  const [downPayment, setDownPayment] = React.useState("");   // will always be 20%
  const [options, setOptions] = React.useState([]);
  const [error, setError] = React.useState("");

  const handleItemChange = (e) => {
    const val = e.target.value;
    setItemValue(val);

    const num = Number(val) || 0;
    const dp = num > 0 ? Math.ceil(num * 0.2) : 0;           // flat 20%
    setDownPayment(dp ? String(dp) : "");
  };

  // User should not change downpayment; ignore manual edits
  const handleDownChange = () => {
    // no-op or you can recompute 20% again if you want to guard
    const num = Number(itemValue) || 0;
    const dp = num > 0 ? Math.ceil(num * 0.2) : 0;
    setDownPayment(dp ? String(dp) : "");
  };

  const handleGenerate = () => {
    setError("");
    const item = Number(itemValue);
    const down = Number(downPayment);

    if (!item || item <= 0) {
      setError("Enter a valid item value.");
      setOptions([]);
      return;
    }

    const expectedDp = Math.ceil(item * 0.2);
    if (down !== expectedDp) {
      setError("Downpayment is fixed at 20% of item value.");
      setDownPayment(String(expectedDp));
      setOptions([]);
      return;
    }

    if (down < 0 || down > item) {
      setError("Downpayment must be between 0 and item value.");
      setOptions([]);
      return;
    }

    const result = calculateEmiOptions(item, down);
    if (result.length === 0) {
      setError("Loan amount must be greater than 0.");
      setOptions([]);
      return;
    }
    setOptions(result);
  };

  const handleReset = () => {
    setItemValue("");
    setDownPayment("");
    setOptions([]);
    setError("");
  };

  return (
    <div className="page page-emi">
      <h2 className="page-title">Check EMI</h2>

      <div className="form-group">
        <label className="field-label">Item Value</label>
        <input
          type="number"
          className="field-input"
          placeholder="Enter item value"
          value={itemValue}
          onChange={handleItemChange}
        />
      </div>

      <div className="form-group">
        <label className="field-label">Downpayment (fixed 20%)</label>
        <input
          type="number"
          className="field-input"
          placeholder="20% of item value"
          value={downPayment}
          onChange={handleDownChange}
          readOnly   // prevent manual change in UI
        />
      </div>

      {error && <p className="text-error">{error}</p>}

      <div className="button-row">
        <button className="btn btn-primary" onClick={handleGenerate}>
          Generate
        </button>
        <button className="btn btn-secondary" onClick={handleReset}>
          Reset
        </button>
      </div>
      <p className="text-note">
        * These EMIs are indicative and calculated as of{" "}
        {new Date().toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
        .
      </p>

      {options.length > 0 && (
        <div className="card-list card-list--emi">
          {options.map((opt) => (
            <div key={opt.key} className="card emi-card">
              <div className="card-header-row">
                <div className="emi-title">
                  {opt.label} • {opt.months} month
                  {opt.months > 1 ? "s" : ""}
                </div>
              </div>

              <div className="emi-row">
                <span className="emi-label">Loan Amount</span>
                <span className="emi-value">
                  ₹{opt.loanAmount.toFixed(0)}
                </span>
              </div>

              <div className="emi-row">
                <span className="emi-label">Net Disbursement</span>
                <span className="emi-value">
                  ₹{opt.netDisbursement.toFixed(0)}
                </span>
              </div>

              <div className="emi-row emi-row--highlight">
                <span className="emi-label">Monthly EMI</span>
                <span className="emi-value emi-value--primary">
                  ₹{opt.emi.toFixed(0)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


export default App;


